import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'

import { useRecoilValue } from 'recoil'

import {
  Button,
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY,
  Link,
  PageHeader
} from 'mailup-web-components'

import {
  canCodeReviewState,
  canSendState
} from 'Pages/MessageCheckupSummary/recoil/state/message'
import { pageState } from 'Pages/MessageCheckupSummary/recoil/state/page'
import { notifyParent } from 'mailup-react-helpers'

import styled from '@emotion/styled'
import { storeGet } from 'Helpers/localStorage'
import useMessageSendAction from 'Hooks/useMessageSendAction'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { STORE_KEY_FEATURES } from 'mailup-react-helpers'

const StyledLink = styled(Link)`
  position: relative;
  top: 10px;
`

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const { id } = useParams()
  const [redirectUrl] = useRedirectorUrl()

  const { title } = useRecoilValue(pageState)
  const canSend = useRecoilValue(canSendState)
  const canCodeReview = useRecoilValue(canCodeReviewState)
  const testInboxPlacement =
    storeGet(STORE_KEY_FEATURES).indexOf('TestInboxPlacement') >= 0

  const handleSendClick = useMessageSendAction(id)

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['EmailCheckupSummary', redirectUrl])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages',
      className: 'test-breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email',
      className: 'test-breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Saved' }),
      'data-mu-test': 'breadcrumb-item__saved',
      className: 'test-breadcrumb-item__saved',
      url: '#',
      onClick: () => history.push('/messages/email/saved')
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.EmailCheckup' }),
      'data-mu-test': 'breadcrumb-item__checkup',
      className: 'test-breadcrumb-item__checkup'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.CheckupSummary' }),
      'data-mu-test': 'breadcrumb-item__checkup__summary',
      className: 'test-breadcrumb-item__checkup__summary'
    }
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.CheckupSummary' }),
      'data-mu-test': 'topmenu-item__checkup__summary',
      className: 'test-topmenu-item__checkup__summary',
      isActive: true,
      onClick: () => null
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.CheckupLinkCheck' }),
      'data-mu-test': 'topmenu-item__checkup__link-check',
      className: 'test-topmenu-item__checkup__link-check',
      onClick: () => {
        const route = `/messages/email/${id}/checkup/linkcheck`
        history.push(route)
      }
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.CheckupSpamCheck' }),
      'data-mu-test': 'topmenu-item__checkup__spam-check',
      className: 'test-topmenu-item__checkup__spam-check',
      onClick: () => history.push(`/messages/email/${id}/checkup/spamcheck`)
    }
    // ...(canCodeReview
    //   ? [
    //       {
    //         label: intl.formatMessage({ id: 'Load.NavMenu.CheckupCodeReview' }),
    //         'data-mu-test': 'topmenu-item__checkup__code-review',
    //         className: 'test-topmenu-item__checkup__code-review',
    //         onClick: () =>
    //           notifyParent('redirectMainFrame', [
    //             `App.aspx#/emailCheckUpCodeReview/${id}`
    //           ])
    //       }
    //     ]
    //   : [])
  ]

  const ControlsComponent = () => (
    <>
      {testInboxPlacement && (
        <StyledLink
          data-mu-test='link-test-inbox'
          variant='highlight'
          onClick={() => {
            window
              .open('https://1eekadb36cd.typeform.com/to/Vj8nXOJe', '_blank', 'noopener,noreferrer')
          }}
        >
          Testa la consegna in inbox
        </StyledLink>
      )}
      {canSend ? (
        <>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button
            kind={BUTTON_VARIANT_PRIMARY}
            size={BUTTON_SIZE_LG}
            onClick={handleSendClick}
            data-mu-test='cta-send'
          >
            {intl.formatMessage({ id: 'Load.MailupCommon.Send' })}
          </Button>
        </>
      ) : null}
    </>
  )

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      title={title}
      ControlsComponent={ControlsComponent}
      loading={!title}
    />
  )
}

export default Header
